import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-error.component',
  imports: [RouterLink],
  template: `<div class="error-container">
  <h1>Ha ocurrido un error</h1>
  <p>Algo salió mal. Por favor, contacta al administrador si el problema persiste.</p>
  <a routerLink="/" class="go-home">Volver al inicio</a>
</div>`,
  styleUrl: './error.component.scss',
})
export class ErrorComponent { }
